<div class="card mt-3">
  <div class="card-header card-header-detail">&nbsp;</div>
  <div class="card-body">
    <div class="row mb-2">
      <div class="col-md-12">
        <span i18n>Der Antrag wurde erfolgreich verschlüsselt, signiert und gespeichert.</span>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <button type="button" (click)="onReprint()" class="btn btn-primary me-2" style="background-color: #367297" i18n>Papierantrag
          drucken
        </button>
        <button type="button" (click)="onBeenden()" class="btn btn-primary" style="background-color: #367297" i18n>Beenden</button>
      </div>
    </div>
  </div>
</div>
